import { DateMetaData } from "burde";
import { Moment } from "moment";
import { regionInfos } from "ui/region-info";

const showRedText = (
    iterationDate: Moment | null,
    metaData: DateMetaData | undefined,
    culture: string | null,
) => {
    const regionInfo = regionInfos.find((x) => x.name === culture);

    if (
        metaData !== undefined &&
        regionInfo &&
        regionInfo.redDays.showHoliday &&
        metaData.red_days &&
        metaData.red_days !== ""
    ) {
        return true;
    }

    if (
        regionInfo &&
        iterationDate !== null &&
        iterationDate.isoWeekday() === regionInfo.redDays.sundayNumber &&
        regionInfo.redDays.showSunday
    ) {
        return true;
    }

    return false;
};

const stringIsNotNullOrEmpty = (text: string): boolean => {
    return !!text;
};

export { showRedText, stringIsNotNullOrEmpty };
